/**
 * サロゲートペアや環境依存文字、改行コードを考慮して文字列内の文字数を1文字1カウントします。
 * undefinedの場合、0を返します。
 * @param str - カウント対象の文字列
 * @returns - 文字列内の文字数
 */
export const countCharacters = (str: string | undefined): number => {
  return Array.from(str || "").length;
};
